import { cx } from '@linaria/core';
import { memo, useState, useRef, useCallback, Suspense, lazy } from 'react';
import { centerCls } from '@pm2/react-utils';
import { NoSSR } from '@utils/react';
import { wrapperCls, containerCls, menuCls, centerCls as centerCls$1, headerCls } from './Header.style.js';
import { Logo } from './Logo.js';
import { MegaMenuWrapper } from './MegaMenu/root.wrapper.js';
import { MobileNavigation } from './Mobile/Navigation.js';
import { Navigation } from './Navigation.js';
import { headerIdentifier } from './selectors.js';
import { StickyLoginHeader } from './sticky-login.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Breadcrumb } from './Breadcrumb/root.breadcrumb.js';

const Tools = /*#__PURE__*/lazy(async () => {
  const {
    Tools
  } = await import('./Tools/index.js');
  return {
    default: Tools
  };
});
const HeaderNonMemoized = () => {
  const [isToolsMounted, setToolsMounted] = useState(false);
  const toolsRef = useRef(null);
  const handleToolsMounted = useCallback(() => {
    setToolsMounted(true);
  }, []);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("header", {
      className: cx(headerCls, headerIdentifier),
      children: [/*#__PURE__*/jsx("div", {
        className: wrapperCls,
        children: /*#__PURE__*/jsx("div", {
          className: cx(centerCls, centerCls$1),
          children: /*#__PURE__*/jsxs("div", {
            className: containerCls,
            children: [/*#__PURE__*/jsx(Logo, {}), /*#__PURE__*/jsxs("div", {
              className: menuCls,
              children: [/*#__PURE__*/jsx(Navigation, {
                isToolsMounted: isToolsMounted
              }), /*#__PURE__*/jsx(NoSSR, {
                children: /*#__PURE__*/jsx(Suspense, {
                  fallback: null,
                  children: /*#__PURE__*/jsx(Tools, {
                    toolsRef: toolsRef,
                    onMount: handleToolsMounted
                  })
                })
              })]
            }), /*#__PURE__*/jsx(MobileNavigation, {
              toolsRef: toolsRef
            })]
          })
        })
      }), /*#__PURE__*/jsx(Breadcrumb, {}), /*#__PURE__*/jsx(MegaMenuWrapper, {})]
    }), /*#__PURE__*/jsx(NoSSR, {
      children: /*#__PURE__*/jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/jsx(StickyLoginHeader, {})
      })
    })]
  });
};
const Header = /*#__PURE__*/memo(HeaderNonMemoized);

export { Header };
//# sourceMappingURL=Header.js.map
